export class PropsParseError extends Error {}

export class UsedOutsideProviderError extends Error {}

export class FormikError extends Error {}
